<template>
  <svg
    t="1691666759350"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="8542"
    width="18"
    height="18"
  >
    <path d="M0 0h486.592v486.592H0z" fill="#F25022" p-id="8543"></path>
    <path
      d="M537.408 0H1024v486.592H537.408z"
      fill="#7FBA00"
      p-id="8544"
    ></path>
    <path d="M0 537.408h486.592V1024H0z" fill="#00A4EF" p-id="8545"></path>
    <path
      d="M537.408 537.408H1024V1024H537.408z"
      fill="#FFB900"
      p-id="8546"
    ></path>
  </svg>
</template>
